@if (headerLocationService.lookupResponse(); as lookupData) {
  <div class="min-w-96">
    <!-- Residential Section -->
    @if (isResidentialAllowed()) {
      <div class="flex flex-col" data-testid="residential-section">
        <div class="flex justify-between">
          <div class="flex flex-row items-center align-baseline mb-4 gap-2">
            <mat-icon svgIcon="icn-home" class="!h-5 !w-5 text-primary-accumin-black-50" />
            <h4 class="!p-0 !m-0 text-primary-accumin-black-50">{{ "General.Residentials" | transloco }}</h4>
            <mat-icon class="!h-4 !w-4" [matTooltip]="residentialSourceTranslationKey() | transloco" svgIcon="icn-info" />
          </div>
        </div>
        <app-tiny-object-list
          [objects]="lookupData.ResidentialObjects"
          (objectSelected)="selectObject($event, 'residential')"
          (createNewObjectClicked)="createNewObjectClicked.emit('residential')"
          createNewTitleTranslationKey="Module.Address.AddNewResidential"
        />
      </div>
    }
    <!-- Commercial Section -->
    @if (isCommercialAllowed()) {
      <div class="flex flex-col mt-4" data-testid="commercial-section">
        <div class="flex justify-between">
          <div class="flex flex-row items-center align-baseline mb-4 gap-2">
            <mat-icon svgIcon="icn-store" class="!h-5 !w-5 text-primary-accumin-black-50" />
            <h4 class="!p-0 !m-0 text-primary-accumin-black-50">{{ "General.Commercials" | transloco }}</h4>
            <mat-icon class="!h-4 !w-4" [matTooltip]="commercialSourceTranslationKey() | transloco" svgIcon="icn-info" />
          </div>
        </div>
        <app-tiny-object-list
          [objects]="lookupData.CommercialObjects"
          (objectSelected)="selectObject($event, 'commercial')"
          (createNewObjectClicked)="createNewObjectClicked.emit('commercial')"
          createNewTitleTranslationKey="Module.Address.AddNewCommercial"
        />
      </div>
    }

    <!-- Rvm Section -->
    @if (isRvmAllowed()) {
      <div class="flex flex-col mt-4" data-testid="rvm-section">
        <div class="flex justify-between">
          <div class="flex flex-row items-center align-baseline mb-4 gap-2">
            <mat-icon svgIcon="icn-store" class="!h-5 !w-5 text-primary-accumin-black-50" />
            <h4 class="!p-0 !m-0 text-primary-accumin-black-50">{{ "General.Rvm" | transloco }}</h4>
            <mat-icon class="!h-4 !w-4" [matTooltip]="'Module.Address.DataSource.Rvm' | transloco" svgIcon="icn-info" />
          </div>
        </div>
        <app-tiny-object-list
          [objects]="lookupData.RvmObjects"
          (objectSelected)="selectObject($event, 'rvm')"
          (createNewObjectClicked)="createNewObjectClicked.emit('rvm')"
          [createNewTitleTranslationKey]="'Module.Address.AddNewRvm' | transloco"
          [createEnabled]="false"
        />
      </div>
    }

    @if (isPlotAllowed()) {
      <div class="flex flex-col mt-4" data-testid="plot-section">
        <div class="flex justify-between">
          <div class="flex flex-row items-center align-baseline mb-4 gap-2">
            <mat-icon svgIcon="icn-flip_to_front" class="!h-5 !w-5 text-primary-accumin-black-50" />
            <h4 class="!p-0 !m-0 text-primary-accumin-black-50">{{ "General.Plots" | transloco }}</h4>
            <mat-icon class="!h-4 !w-4" [matTooltip]="plotSourceTranslationKey() | transloco" svgIcon="icn-info" />
          </div>
        </div>
        <app-tiny-plot-object-list [plotObjects]="lookupData.PlotObjects" (objectSelected)="selectPlotObject($event)" />
      </div>
    }

    <!-- No Permissions Section -->
    @if (!isCommercialAllowed() && !isResidentialAllowed() && !isRvmAllowed()) {
      <div class="flex flex-col mt-4" data-testid="no-permissions-section">
        <div class="flex items-center gap-3 p-4 bg-gray-100 rounded-lg">
          <mat-icon class="!h-6 !w-6 text-gray-500">lock</mat-icon>
          <span class="text-gray-700">{{ "Exception.Failure.Status.4" | transloco }}</span>
        </div>
      </div>
    }
  </div>
}
